import React, {Component} from "react";
import {withRouter} from "react-router-dom";

/**
 * 페이지 뒤로 버튼
 */
class PageBack extends Component {
    constructor(props) {
        super(props);

        this.history = props.history;
    }

    back() {
        if(this.history) {
            this.history.goBack();
        }
    }

    render() {
        return (
            <span className="back-wrap" onClick={() => this.back()}>
                <img src="/images/icon-back.png" alt={'이전'}/>
            </span>
        );
    }
}

export default withRouter(PageBack);



// WEBPACK FOOTER //
// ./src/pages/components/buttons/page-back.jsx